module.exports = __webpack_public_path__ + "img/visuel_navigateur_obsolete.4543937a.svg";